import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IEmployee } from '../types';
import { EmployeeRow } from './employee-row';
import { useAuthRole } from '@app/utils';

interface Props {
  tableProps: TableProps;
  rows?: IEmployee[];
  loading: boolean;
}

const EmployeeList = ({ tableProps, rows, loading }: Props) => {
  const { isSuperAdmin } = useAuthRole();

  const TABLE_HEAD = [
    { id: 'id', label: 'Id', align: 'center' },
    { id: 'firstName', label: 'Name', align: 'center' },
    { id: 'email', label: 'Email', align: 'center' },
    { id: 'phone', label: 'Phone', align: 'center' },
    { id: 'role', label: 'Role', align: 'center' },
    ...(isSuperAdmin
      ? [{ id: 'manager', label: 'Manager', align: 'center', sortable: false }]
      : []),
    { id: 'status', label: 'Status', align: 'center' },
    { id: 'action', label: 'Action', align: 'center', sortable: false },
  ];

  return (
    <PaginatedTable<IEmployee>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <EmployeeRow
          row={row}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};

export { EmployeeList };
